<template lang="pug">
section
  .banner.d-flex.justify-content-center.align-items-center
    .banner-text
      vue-typed-js(
        :strings="['欢迎光临，看看需要什么装备?']",
        :fadeOut="true",
        :startDelay="1000"
      )
        h3.text-white.text-center
          | 商城老板：
          br
          span.typing
      img.confound(src="http://res.99ro.top/web-assets/img/emotion/04.gif")
  .container
    Breadcrumb(:breadcrumb="category")
    .content
      .category-list
        ul.list-items.sticky-list
          li
            a.items(
              href="#",
              @click.prevent="(category.title = '全部商品'), getProducts('all')",
              :class="{ active: category == '全部商品' }"
            )
              img.items-img(src="http://res.99ro.top/web-assets/img/product/poringking.gif")
              div 全部商品
          li
            a.items(
              href="#",
              @click.prevent="(category.title = '武器类'), getProducts('weapon')",
              :class="{ active: category == '武器类' }"
            )
              img.items-img(src="http://res.99ro.top/web-assets/img/product/weapon.png")
              div 武器类
          li
            a.items(
              href="#",
              @click.prevent="(category.title = '头饰类'), getProducts('header')",
              :class="{ active: category == '头饰类' }"
            )
              img.items-img(src="http://res.99ro.top/web-assets/img/product/header.gif")
              div 头饰类
          li
            a.items(
              href="#",
              @click.prevent="(category.title = '防具类'), getProducts('armor')",
              :class="{ active: category == '防具类' }"
            )
              img.items-img(src="http://res.99ro.top/web-assets/img/product/armor.png")
              div 防具类
          li
            a.items(
              href="#",
              @click.prevent="(category.title = '卡片类'), getProducts('card')",
              :class="{ active: category == '卡片类' }"
            )
              img.items-img(src="http://res.99ro.top/web-assets/img/product/card.png")
              div 卡片类
          li
            a.items(
              href="#",
              @click.prevent="(category.title = '套装类'), getProducts('pack')",
              :class="{ active: category == '套装类' }"
            )
              img.items-img(src="http://res.99ro.top/web-assets/img/product/pack.gif")
              div 套装类
          li
            a.items(
              href="#",
              @click.prevent="(category.title = '其它类'), getProducts('other')",
              :class="{ active: category == '其它类' }"
            )
              img.items-img(src="http://res.99ro.top/web-assets/img/product/other.png")
              div 其它类
      .products
        h3 {{ category.title }}
        ul.products-list
          li.products-item(v-for="item in getCategory", :key="item.item_id")
            .products-top.text-center
              .badge.badge-danger.category-top {{ item.type_name }}
              img.card-img(
                :src="`http://res.99ro.top/assets/collection/${item.item_id}.gif`",
                onerror="this.src='http://res.99ro.top/assets/collection/default.gif'",
                style="margin-bottom:10px;"
              )
            .products-content.p-2
              h6.font-weight-bold
                span.text-ro {{ item.item_name }}
              div
                .description.text-truncate
                  | {{ item.item_desctable }}
              .d-flex.justify-content-between
                | 售价 {{ item.cash }} Vis
                small(style="padding-top:3px;") 奖励 {{ item.rebatetoken }} 返利币
            .products-footer
              .products-btn
                router-link.btn.btn-outline-ro.btn-block(
                  :to="'/detailed/' + item.item_id"
                )
                  | 查看详情
  audio#roBGM(loop="", muted="", webkit-playsinline="true", playsinline="true")
    source(src="http://res.99ro.top/web-assets/audio/login@2.mp3", type="audio/mpeg")
</template>

<script>
import Breadcrumb from './Breadcrumb';
import * as shopAPI from '@/api/shop';

export default {
  data() {
    return {
      products: [],
      cacheModelItem: {},
      modelTitle: '',
      counts: 0,
      status: {
        loadingID: '',
      },
      category: {
        title: '全部商品',
        type: 'all'
      },
    };
  },
  methods: {
    getProducts(type) {
      const vm = this;
      vm.category.type = type || 'all';
      shopAPI.getList().then((data) => {
        //  vm.products = response.data.products;
        vm.products = data;
        // console.log(vm.products);

        // vm.$bus.$emit('message:push',
        //     `出現錯誤惹，好糗Σ( ° △ °|||)︴
        //     ${response.data.message}`
        //     , 'danger');
      })
    },
    autoPlayMusic() {
      const roBGM = document.getElementById('roBGM');
      if (roBGM.paused) {
        setTimeout(() => {
          if (roBGM) {
            roBGM.play();
            roBGM.volume = 0.2;
          }
        }, 1500);
      }
    },
  },
  computed: {
    getCategory() {
      const vm = this;
      return vm.products.filter((item) => {
        return vm.category.type === 'all' || item._type === vm.category.type;
      });
    },
  },
  components: {
    Breadcrumb,
  },
  created() {
    this.getProducts('all');
    this.category.title = this.$route.params.data ? this.$route.params.data : '全部商品';
  },
  mounted() {
    this.autoPlayMusic();
    setTimeout(() => {
      const confound = document.querySelector('.confound');
      if (confound) confound.style.opacity = 1;
    }, 2000);
  },
};
</script>


<style lang="scss" scoped>
.banner {
  background-image: url(http://res.99ro.top/web-assets/img/background2.jpg);
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 60px;
  height: 500px;
}
.banner-text {
  background-color: rgba(0, 0, 0, 0.45);
  padding: 10px;
  border-radius: 10px;
  display: flex;
  position: relative;
}
.confound {
  position: absolute;
  width: 100px;
  top: -40%;
  left: -24%;
  opacity: 0;
  transition: all 0.5s;
}
.sticky-list {
  background-color: #fff;
  top: 99.88px;
  position: sticky;
}
.content {
  display: flex;
  .category-list {
    width: 20%;
    @media (max-width: 992px) {
      width: 100%;
    }
  }
  .products {
    width: 80%;
    @media (max-width: 992px) {
      width: 100%;
    }
  }
  @media (max-width: 992px) {
    display: block;
  }
}
.list-items {
  list-style: none;
  margin: 0;
  padding: 0;
  @media (max-width: 992px) {
    display: flex;
    flex-wrap: wrap;
  }
  li {
    text-align: center;
    margin-bottom: 5px;
    @media (max-width: 992px) {
      width: 33.33333333%;
    }
  }
  .items {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    padding: 10px;
    border: 1px solid #ced4da;
    transition: all 0.5s;
    color: #769bd3;
    font-weight: 800;
    text-decoration: none;
    &:hover {
      color: #044273;
      border: 1px solid #769bd3;
    }
    &.active {
      color: #044273;
      border: 1px solid #769bd3;
    }
    @media (max-width: 992px) {
      flex-direction: column;
    }
  }
}
.products {
  margin-left: 40px;
  @media (max-width: 992px) {
    margin-left: 0px;
  }
  .products-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
.products-item {
  display: flex;
  box-shadow: 0 1px 5px #000;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 15px;
  transition: all 0.5s;
  &:hover {
    box-shadow: 0 2px 10px #000;
  }
  .products-top {
    width: 20%;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .products-content {
    width: 60%;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .products-footer {
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .products-btn {
    width: 100%;
  }
  .products-btn-disabled {
    width: 100%;
  }
  .description {
    height: 103px;
  }
  @media (max-width: 768px) {
    display: block;
  }
}
.items-img {
  max-width: 50px;
  margin-right: 10px;
}
.products-top {
  position: relative;
  .category-top {
    position: absolute;
    top: 0px;
    right: 0px;
  }
}
.card-img {
  width: 150px;
  height: 200px;
  @media (max-width: 992px) {
    width: 100px;
    height: 140px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Products.vue